module.exports = __webpack_public_path__ + "img/empty-plate.ab7b1641.png";